<template>
<div class="bottom">
    <div :class="['send', loading ? 'send_loading' : '']" @click="sendEmail">{{$t("发送邮件#!!!#src/pages/H5/Cloud/components/email/EmailBottom.vue_1")}}    </div>
    <div v-if="!isPreview" :class="['preview', loading ? 'preview_loading' : '']" @click="previewEmail">{{$t("预览邮件#!!!#src/pages/H5/Cloud/components/email/EmailBottom.vue_1")}}    </div>
    <div v-else class="back" @click="backToSend">{{$t("返回#!!!#src/pages/H5/Cloud/components/email/EmailBottom.vue_1")}}</div>
  </div>
</template>

<script>
export default {
  name: "test_vue",
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isPreview: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  emits: ["sendEmail", "previewEmail", "backToSend"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    sendEmail() {
      if (this.loading) {
        return;
      }
      this.$emit("sendEmail");
    },
    previewEmail() {
      if (this.loading) {
        return;
      }
      this.$emit("previewEmail");
    },
    backToSend() {
      this.$emit("backToSend");
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  height: 60px;
  width: 100%;
  position: relative;

  .send_loading {
    cursor: not-allowed !important;
    background-color: #c0c4cc;
    opacity: 0.3;
  }

  .send {
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: 0px;
    width: 88px;
    height: 36px;
    background: #5c70ff;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    user-select: none;

    &:hover {
      background-color: #6d7dff;
    }
  }

  .preview_loading {
    cursor: not-allowed !important;
    background-color: #c0c4cc;
    opacity: 0.3;
  }

  .preview {
    cursor: pointer;
    position: absolute;
    right: 128px;
    top: 0px;
    width: 88px;
    height: 36px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    color: #222329;
    text-align: center;
    border: 1px solid #e8e9ee;
    line-height: 36px;
    user-select: none;
    &:hover {
      background-color: #f4f6f9;
    }
  }

  .back {
    cursor: pointer;
    position: absolute;
    right: 128px;
    top: 0px;
    width: 88px;
    height: 36px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    color: #222329;
    text-align: center;
    border: 1px solid #e8e9ee;
    line-height: 36px;
    &:hover {
      background-color: #f4f6f9;
    }
  }
}
</style>
